import React from 'react'
import * as PropTypes from 'prop-types'
import {InferPropTypes} from '@modifi/typescript-utils'
import {Container, H3, H4, H5, H6, Highlight, Strong} from '@modifi/ui'
import {Trans} from '@modifi/plugin-i18n'

import {Anchor, StyledP, StyledLi} from './styles'
import Picture from '../../ui/cms-picture'
import {DefaultComponentWrapper} from '../common'

const propTypes = {
  body: PropTypes.string,
  backgroundColor: PropTypes.string,
}
const defaultProps = {
  body: '',
  backgroundColor: undefined,
}

const blogPostComponentMapping = {
  h1: <H3 as="h2" mt={48} mb={24} />,
  h2: <H3 as="h2" mt={48} mb={24} />,
  h3: <H3 mt={40} mb={28} />,
  h4: <H4 mt={40} mb={24} />,
  h5: <H5 mt={40} mb={24} />,
  h6: <H6 mt={40} mb={16} />,
  span: <span />,
  a: <Anchor target="_blank" rel="noopener noreferrer" />,
  img: <Picture objectFit="fill" />,
  li: <StyledLi />,
  ul: <ul />,
  ol: <ol />,
  p: <StyledP />,
  figure: <figure />,
  figcaption: <figcaption />,
  b: <Strong />,
  i: <i />,
  pre: <pre />,
  code: <Highlight />,
  section: <section />,
}

export type WysiwygComponentProps = InferPropTypes<typeof propTypes, typeof defaultProps>

export const WysiwygComponent: React.FC<WysiwygComponentProps> = ({body, backgroundColor}) => (
  <DefaultComponentWrapper backgroundColor={backgroundColor} padding={0}>
    <Container>
      {body && <Trans defaults={body || ''} components={blogPostComponentMapping} />}
    </Container>
  </DefaultComponentWrapper>
)

WysiwygComponent.propTypes = propTypes

WysiwygComponent.defaultProps = defaultProps

export default WysiwygComponent
